export default __webpack_public_path__ + "static/media/coworking.3d1dfffe.svg";